import * as Autocompletes from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Autocompletes.json';
import * as BankBranches from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Bank_Branches.json';
import * as Branches from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Branches.json';
import * as CalculatorCashResults from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Calculator_Cash_Results.json';
import * as CalculatorForm from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Calculator_Form.json';
import * as CalculatorResults from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Calculator_Results.json';
import * as CalculatorSchedule from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Calculator_Schedule.json';
import * as CalculatorSchedulePrintout from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Calculator_Schedule_Printout.json';
import * as CalculatorScheduleTable from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Calculator_Schedule_Table.json';
import * as ClientDetails from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Client_Details.json';
import * as ClientDetailsBik from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Client_Details_Bik.json';
import * as ClientDetailsDocuments from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Client_Details_Documents.json';
import * as ClientList from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Client_List.json';
import * as Commons from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Commons.json';
import * as CreateDealModal from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Create_Deal_Modal.json';
import * as Dashboard from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Dashboard.json';
import * as DateFilters from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Date_Filters.json';
import * as DealAttributesDictionary from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Deal_Attributes_Dictionary.json';
import * as DealDetails from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Deal_Details.json';
import * as Deals from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Deals.json';
import * as DealsList from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Deals_List.json';
import * as DelegationLists from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Delegation_Lists.json';
import * as DivisionDetails from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Division_Details.json';
import * as Divisions from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Divisions.json';
import * as Enums from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Enums.json';
import * as ErrorPages from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Error_Pages.json';
import * as FinancialInstitutions from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Financial_Institutions.json';
import * as Forum from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Forum.json';
import * as FpComponents from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Fp_Components.json';
import * as FpMessage from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Fp_Message.json';
import * as Lenda from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Lenda.json';
import * as LoanApplications from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Loan_Applications.json';
import * as Login from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Login.json';
import * as Multiform from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Multiform.json';
import * as MultiformDictionary from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Multiform_Dictionary.json';
import * as Navigation from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Navigation.json';
import * as NewClientModal from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/New_Client_Modal.json';
import * as Notifications from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Notifications.json';
import * as NPS from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/NPS.json';
import * as Opinions from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Opinions.json';
import * as Pagination from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Pagination.json';
import * as Partners from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Partners.json';
import * as Prospects from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Prospects.json';
import * as SettlementDetails from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Settlement_Details.json';
import * as Settlements from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Settlements.json';
import * as SmsEmails from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Sms_Emails.json';
import * as UseList from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Use_List.json';
import * as UserEditPanel from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/User_Edit_Panel.json';
import * as UsersManagements from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Users_Management.json';
import * as Validation from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Validation.json';
import * as SnackbarService from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/SnackbarService.json';
import * as Teleconference from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Teleconference.json';
import * as Issues from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Issues.json';
import * as Procedures from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Procedures.json';
import * as MeetTeam from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Meet_Team.json';
import * as Regulation from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Regulation.json';
import * as SmeComparator from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Sme_Comparator.json';
import * as ViennaLifePromo from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/DE/Vienna_Life_Promo.json';

import {I18NInterface} from '@/services/enumTranslator/I18NInterface';
import * as Accreditation from '@/services/enumTranslator/langDictionaries/jsonDicts/Namespaces/PL/Accreditation.json';

const translationsArray = [Autocompletes,
  BankBranches,
  Branches,
  CalculatorCashResults,
  CalculatorForm,
  CalculatorResults,
  CalculatorSchedule,
  CalculatorSchedulePrintout,
  CalculatorScheduleTable,
  ClientDetails,
  ClientDetailsBik,
  ClientDetailsDocuments,
  ClientList,
  Commons,
  CreateDealModal,
  Dashboard,
  DateFilters,
  DealAttributesDictionary,
  DealDetails,
  Deals,
  DealsList,
  DelegationLists,
  DivisionDetails,
  Divisions,
  Enums,
  ErrorPages,
  FinancialInstitutions,
  Forum,
  FpComponents,
  FpMessage,
  Lenda,
  LoanApplications,
  Login,
  Multiform,
  MultiformDictionary,
  Navigation,
  NewClientModal,
  Notifications,
  NPS,
  Opinions,
  Pagination,
  Partners,
  Prospects,
  SettlementDetails,
  Settlements,
  SmsEmails,
  UseList,
  UserEditPanel,
  UsersManagements,
  Validation,
  Accreditation,
  SnackbarService,
  Teleconference,
  Procedures,
  MeetTeam,
  Issues,
  Regulation,
  SmeComparator,
  ViennaLifePromo,
];

export const reducedJsonDictDE: I18NInterface = translationsArray.reduce((prev, current) => {
  const parsedCurrent = JSON.parse(JSON.stringify(current));
  return {...prev, ...parsedCurrent,};
}, {}) as typeof Autocompletes & typeof BankBranches
  & typeof Branches
  & typeof CalculatorCashResults
  & typeof CalculatorForm
  & typeof CalculatorResults
  & typeof CalculatorSchedule
  & typeof CalculatorSchedulePrintout
  & typeof CalculatorScheduleTable
  & typeof ClientDetails
  & typeof ClientDetailsBik
  & typeof ClientDetailsDocuments
  & typeof ClientList
  & typeof Commons
  & typeof CreateDealModal
  & typeof Dashboard
  & typeof DateFilters
  & typeof DealAttributesDictionary
  & typeof DealDetails
  & typeof Deals
  & typeof DealsList
  & typeof DelegationLists
  & typeof DivisionDetails
  & typeof Divisions
  & typeof Enums
  & typeof ErrorPages
  & typeof FinancialInstitutions
  & typeof Forum
  & typeof FpComponents
  & typeof FpMessage
  & typeof Lenda
  & typeof LoanApplications
  & typeof Login
  & typeof Multiform
  & typeof MultiformDictionary
  & typeof Navigation
  & typeof NewClientModal
& typeof Notifications
& typeof NPS
& typeof Opinions
  & typeof Pagination
  & typeof Partners
  & typeof Prospects
  & typeof SettlementDetails
  & typeof Settlements
  & typeof SmsEmails
  & typeof UseList
  & typeof UserEditPanel
  & typeof UsersManagements
  & typeof Validation
  & typeof Accreditation
  & typeof SnackbarService
  & typeof Teleconference
  & typeof Issues
  & typeof Procedures
  & typeof MeetTeam
  & typeof Regulation
  & typeof SmeComparator
  & typeof ViennaLifePromo;
